export default "__VITE_ASSET__a8795d59__"